import NewForm from "../Components/NewForm";

function New() {
    return (
        <div>
            <NewForm />
        </div>
    );
};

export default New;
